import { apiCall } from './BaseAction';
import { Dispatch } from 'redux';
import {
  FilterContactsList,
  GetContactsList,
  TFilterContactsListAction,
  TGetContactsListAction,
} from '../types/Contacts';

export const getContactsList = () => {
  return apiCall<TGetContactsListAction, null>(
    GetContactsList,
    'GET',
    '/contacts',
    true
  );
};

export const filterContactsList = (search: string, location: string, group: string) => {
  return (dispatch: Dispatch<TFilterContactsListAction>) => {
    dispatch({
      type: FilterContactsList.SUBMIT,
      payload: {
        search,
        location,
        group
      },
    });
  };
};